export default (() => {
  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.js-gtag').forEach(function (el) {
      // <a class="js-gtag" data-on="click" data-event="add_to_cart" data-value="100">Add to Cart</a>
      if (typeof window.gtag === 'undefined') {
        return
      }
      let log_event = function (dom) {
        if (dom.dataset.event) {
          let value = dom.dataset.value
          if (value) {
            if (value.startsWith('{') && value.endsWith('}')) {
              value = JSON.parse(value)
              if (dom.dataset.quantityEl && value.items) {
                value.items[0].quantity = parseInt(
                  document.querySelector(dom.dataset.quantityEl).value
                )
              }
              if (dom.dataset.valueEl) {
                let valueEl = document.querySelector(dom.dataset.valueEl)
                value.value = parseFloat(
                  valueEl.dataset.gaValue || valueEl.value
                ).toFixed(2)
              }
            }
            window.gtag('event', dom.dataset.event, value)
          } else {
            window.gtag('event', dom.dataset.event)
          }
        }
      }
      if (el.dataset.on) {
        el.addEventListener(el.dataset.on, function () {
          log_event(this)
        })
      } else {
        log_event(el)
      }
    })
  })
})()
